import { defaultHttpClient } from '../../httpClient';
import type {
  PostValidateEmailAuthRequest,
  PostValidateEmailAuthResponse,
} from './types';

/**
 * 아이디(이메일) 찾기 — SMS 인증번호를 검증 후 이메일 확인.
 */
export const postValidateEmailAuth = (
  params: PostValidateEmailAuthRequest,
) => {
  return defaultHttpClient
    .request<PostValidateEmailAuthResponse>({
      method: 'POST',
      url: '/api/v2/members/validate_email_auth/',
      data: params,
    })
    .then(result => result.data);
};
